/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  HandleCallbackParams,
  InstallSlackAppParams,
  InvoiceActionV3,
  SlackChannelDto,
  SlackNotificationSettingsRequestDto,
  SlackNotificationSettingsResponseDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class SlackAppController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags slack-app-controller
   * @name UnlinkUserProfile
   * @request POST:/api/v1/slack/user-profile/unlink
   */
  unlinkUserProfile = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/slack/user-profile/unlink`,
      method: 'POST',
      ...params,
    })

  static unlinkUserProfilePath = '/v1/slack/user-profile/unlink'
  static unlinkUserProfileMethod = 'POST'
  /**
   * No description
   *
   * @tags slack-app-controller
   * @name GetNotificationSettings
   * @request GET:/api/v1/slack/notification-settings
   */
  getNotificationSettings = (params: RequestParams = {}) =>
    this.http.request<SlackNotificationSettingsResponseDto, any>({
      path: `/v1/slack/notification-settings`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getNotificationSettingsPath = '/v1/slack/notification-settings'
  static getNotificationSettingsMethod = 'GET'
  /**
   * No description
   *
   * @tags slack-app-controller
   * @name UpdateNotificationSettings
   * @request POST:/api/v1/slack/notification-settings
   */
  updateNotificationSettings = (
    data: SlackNotificationSettingsRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/slack/notification-settings`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateNotificationSettingsPath = '/v1/slack/notification-settings'
  static updateNotificationSettingsMethod = 'POST'
  /**
   * No description
   *
   * @tags slack-app-controller
   * @name SetNotificationChannel
   * @request POST:/api/v1/slack/notification-channel
   */
  setNotificationChannel = (data: SlackChannelDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/slack/notification-channel`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static setNotificationChannelPath = '/v1/slack/notification-channel'
  static setNotificationChannelMethod = 'POST'
  /**
   * No description
   *
   * @tags slack-app-controller
   * @name ProcessEvent
   * @request POST:/api/v1/slack/events
   */
  processEvent = (params: RequestParams = {}) =>
    this.http.request<InvoiceActionV3, any>({
      path: `/v1/slack/events`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static processEventPath = '/v1/slack/events'
  static processEventMethod = 'POST'
  /**
   * No description
   *
   * @tags slack-app-controller
   * @name UnlinkAccount
   * @request POST:/api/v1/slack/account/unlink
   */
  unlinkAccount = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/slack/account/unlink`,
      method: 'POST',
      ...params,
    })

  static unlinkAccountPath = '/v1/slack/account/unlink'
  static unlinkAccountMethod = 'POST'
  /**
   * No description
   *
   * @tags slack-app-controller
   * @name CheckUserProfile
   * @request GET:/api/v1/slack/user-profile
   */
  checkUserProfile = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/slack/user-profile`,
      method: 'GET',
      ...params,
    })

  static checkUserProfilePath = '/v1/slack/user-profile'
  static checkUserProfileMethod = 'GET'
  /**
   * No description
   *
   * @tags slack-app-controller
   * @name HandleCallback
   * @request GET:/api/v1/slack/oauth/callback
   */
  handleCallback = (query: HandleCallbackParams, params: RequestParams = {}) =>
    this.http.request<InvoiceActionV3, any>({
      path: `/v1/slack/oauth/callback`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static handleCallbackPath = '/v1/slack/oauth/callback'
  static handleCallbackMethod = 'GET'
  /**
   * No description
   *
   * @tags slack-app-controller
   * @name InstallSlackApp
   * @request GET:/api/v1/slack/install
   */
  installSlackApp = (query: InstallSlackAppParams, params: RequestParams = {}) =>
    this.http.request<InvoiceActionV3, any>({
      path: `/v1/slack/install`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static installSlackAppPath = '/v1/slack/install'
  static installSlackAppMethod = 'GET'
  /**
   * No description
   *
   * @tags slack-app-controller
   * @name GetAllChannels
   * @request GET:/api/v1/slack/channels
   */
  getAllChannels = (params: RequestParams = {}) =>
    this.http.request<SlackChannelDto[], any>({
      path: `/v1/slack/channels`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAllChannelsPath = '/v1/slack/channels'
  static getAllChannelsMethod = 'GET'
  /**
   * No description
   *
   * @tags slack-app-controller
   * @name CheckAccount
   * @request GET:/api/v1/slack/account
   */
  checkAccount = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/slack/account`,
      method: 'GET',
      ...params,
    })

  static checkAccountPath = '/v1/slack/account'
  static checkAccountMethod = 'GET'
}
